import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.overlayDark};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1.6rem;
`;

export const Sheet = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 1.6rem;
  padding: 2.4rem;
  width: 100%;
  max-width: 48rem;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 2rem 4rem ${({ theme }) => theme.colors.shadowSoft};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1.2rem;
  margin-bottom: 1.2rem;
`;

export const HeaderText = styled.div`
  flex: 1;
`;

export const Title = styled.h2`
  font-size: 1.8rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin: 0 0 0.4rem;
`;

export const Subtitle = styled.p`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin: 0;
  line-height: 1.5;
`;

export const CloseBtn = styled.button`
  background: none;
  border: none;
  font-size: 1.8rem;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.slateGrey};
  padding: 0.4rem 0.8rem;
  line-height: 1;

  &:hover {
    color: ${({ theme }) => theme.colors.darkSlate};
  }
`;

export const HelperText = styled.p`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin: 0 0 0.6rem;
`;

export const MessageInput = styled.textarea`
  width: 100%;
  min-height: 10rem;
  padding: 1.2rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 1rem;
  font-size: 1.4rem;
  font-family: inherit;
  color: ${({ theme }) => theme.colors.darkSlate};
  background-color: ${({ theme }) => theme.colors.white};
  resize: vertical;
  margin-bottom: 1.6rem;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.accent};
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
`;

export const PrimaryBtn = styled.button`
  flex: 1;
  min-width: 12rem;
  padding: 1.2rem 1.6rem;
  border-radius: 1rem;
  border: none;
  background-color: ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.white};
  font-size: 1.4rem;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SecondaryBtn = styled.button`
  flex: 1;
  min-width: 12rem;
  padding: 1.2rem 1.6rem;
  border-radius: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.darkSlate};
  font-size: 1.4rem;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.surface};
  }
`;

export const DismissRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1.2rem;
`;

export const DismissBtn = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.slateGrey};
  font-size: 1.3rem;
  cursor: pointer;
  padding: 0.4rem 0.8rem;

  &:hover {
    color: ${({ theme }) => theme.colors.darkSlate};
  }
`;
